import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";
import type { FC } from "react";
import { cva, type VariantProps } from "class-variance-authority";

const stepVerticalLineVariants = cva("w-[1px] grow border-r-[1px]", {
    variants: {
        variant: {
            brand: "border-border-brand",
            neutral: "border-border-base",
        },
    },
    defaultVariants: {
        variant: "neutral",
    },
});

type StepVerticalLineProps = PropsWithClassName & VariantProps<typeof stepVerticalLineVariants>;

export const StepVerticalLine: FC<StepVerticalLineProps> = ({ className, variant }) => {
    return <div className={cn(stepVerticalLineVariants({ variant }), className)} />;
};
